import {
  ElogParticipant,
  Protocol,
  MeetingInstance,
} from "@services/meetings/types";

export const isValidForm = (form: Partial<ElogParticipant>) => {
  const areDefined = (keys: (keyof typeof form)[]) =>
    keys.every((key) => form[key] !== undefined);
  const isQuantityOverZero = () => (form.quantity ?? 0) > 0;
  const hasValidBillingCode = () =>
    !form.billingCode ||
    (form.billingCode && form.description && isQuantityOverZero());
  const validateRoom = () =>
    Boolean(form.device) === Boolean(form.room) || form.externalId;
  return (
    areDefined(["connectTime", "protocol"]) &&
    validateRoom() &&
    hasValidBillingCode()
  );
};

export const withDefaultValues = (
  participant?: Partial<ElogParticipant>,
  meeting?: MeetingInstance
): Partial<ElogParticipant> => ({
  protocol: Protocol.H323,
  dialIn: canHaveEmptyDialIn(participant) ? undefined : true,
  connectTime: meeting && meeting.start,
  disconnectTime: meeting && meeting.end,
  ...(participant ?? {}),
});

export const canHaveEmptyDialIn = (participant?: Partial<ElogParticipant>) =>
  Boolean(participant?.dialIn === undefined);
